import { gql } from '@apollo/client';

const UPDATE_PRE_AUTH = gql`
  mutation updatePreAuthStatus($input: UpdatePreAuthStatusInput!) {
    updatePreAuthStatus(input: $input) {
      status
      message
    }
  }
`;

export default {
  UPDATE_PRE_AUTH,
};
